import { render, staticRenderFns } from "./submit_claims_content.vue?vue&type=template&id=5f51f91f&scoped=true"
import script from "./submit_claims_content.vue?vue&type=script&lang=js"
export * from "./submit_claims_content.vue?vue&type=script&lang=js"
import style0 from "./submit_claims_content.vue?vue&type=style&index=0&id=5f51f91f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51f91f",
  null
  
)

export default component.exports